import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from '../sidebar/Sidebar';
import { CssBaseline } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import Splash from '../../Splash';
import { CampaignContext } from '../../contexts/CampaignContext';
import axios from 'axios';
import IResponse from '../../interfaces/response';
import { IMedia } from '../../interfaces/campaign';
import { ISplashState } from '../../interfaces/common';
import { UserContext } from '../../contexts/UserContext';
import { IUser } from '../../interfaces/user';
import { useSidebar } from '../../contexts/SidebarContext';
import clsx from 'clsx';
import Header from '../Header';

export default function App() {
	const [splashStatus, setSpalshStatus] = useState<ISplashState>('loading');
	const { sidebarOpen, sidebarPin, sidebarVarient } = useSidebar();

	const location = useLocation();
	const pathname = location.pathname;

	const isDashboard = pathname === '/' || pathname === '/dashboard';

	const { setFetchedMedias } = useContext(CampaignContext);
	const { setUser } = useContext(UserContext);

	const fetchUser = async () => {
		const res = await axios<IResponse<IUser>>({
			url: '/user',
		});

		if (res.data.success) {
			setUser(res.data.data);
		}
	};

	const fetchMedias = async () => {
		const res = await axios<IResponse<IMedia[]>>({
			url: '/medias',
		});

		if (res.data.success) {
			setFetchedMedias(res.data.data);
		}
	};

	const fetchData = async () => {
		try {
			setSpalshStatus('loading');
			await Promise.all([fetchMedias(), fetchUser()]);
			setSpalshStatus('finish');
		} catch (error) {
			console.error('Error fetching data:', error);
			setSpalshStatus('error');
		}
	};

	useEffect(() => {
		fetchData();
	}, []);

	if (splashStatus !== 'finish') {
		return <Splash status={splashStatus} onRefetch={fetchData} />;
	}

	const paddinStart = sidebarVarient === 'temporary' ? 'ps-0' : sidebarPin && sidebarOpen ? 'ps-64' : 'ps-16';

	return (
		<div className="h-full">
			<CssBaseline />
			<Sidebar />
			<div className={clsx('flex grow flex-col', paddinStart)}>
				<div className="container mx-auto px-4">
					{(!isDashboard || sidebarVarient === 'temporary') && <Header />}
					<div className="flex min-w-full flex-grow justify-center">
						<Outlet />
					</div>
				</div>
			</div>
		</div>
	);
}
